var App = App || {};

App.BrazeBanner = (function ($) {
    'use strict';

    function init() {
        
        if (APIKey) {
            braze.initialize(APIKey, {
                baseUrl: "https://sdk.iad-05.braze.com/",
                allowUserSuppliedJavascript: true,

            });
         
            braze.automaticallyShowInAppMessages();

            const placementId = PlacementID;
            const bannerContainer = document.getElementById("homepage-banner-container");

            if (bannerContainer) {
                braze.subscribeToBannersUpdates(function () {
                    const banner = braze.getBanner(placementId);

                    if (!banner) {
                        return;
                    }
            
                    braze.insertBanner(banner, bannerContainer);
                   
                    if (banner.isControl) {
                        bannerContainer.style.display = 'none';
                    }
                });
               
                braze.requestBannersRefresh([placementId, "navigation_square_banner"]);
            }

            braze.openSession();


        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.BrazeBanner.init();
});